var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1334 2.79581C15.5917 3.69525 15.5917 4.87267 15.5917 7.22752V9.49705C15.5917 9.73227 15.5917 9.84983 15.587 9.94914C15.4845 12.1151 13.7517 13.8478 11.5858 13.9503C11.4865 13.955 11.3553 13.955 11.093 13.955L11.0256 13.9551C10.1677 13.9606 9.33188 14.2284 8.63057 14.7227L8.58598 14.7544L6.3905 16.3226C5.63788 16.8602 4.64887 16.0838 4.99237 15.2251C5.2357 14.6168 4.7877 13.955 4.13252 13.955H3.62648C1.87478 13.955 0.454742 12.535 0.454742 10.7833V7.22752C0.454742 4.87267 0.454742 3.69525 0.913027 2.79581C1.31614 2.00464 1.95939 1.3614 2.75055 0.958285C3.64999 0.5 4.82741 0.5 7.18227 0.5H8.86415C11.219 0.5 12.3964 0.5 13.2959 0.958285C14.0871 1.3614 14.7303 2.00464 15.1334 2.79581ZM5.50039 7.22752C5.50039 7.69196 5.12388 8.06846 4.65945 8.06846C4.19501 8.06846 3.8185 7.69196 3.8185 7.22752C3.8185 6.76309 4.19501 6.38658 4.65945 6.38658C5.12388 6.38658 5.50039 6.76309 5.50039 7.22752ZM8.86415 7.22752C8.86415 7.69196 8.48764 8.06846 8.02321 8.06846C7.55877 8.06846 7.18227 7.69196 7.18227 7.22752C7.18227 6.76309 7.55877 6.38658 8.02321 6.38658C8.48764 6.38658 8.86415 6.76309 8.86415 7.22752ZM11.387 8.06846C11.8514 8.06846 12.2279 7.69196 12.2279 7.22752C12.2279 6.76309 11.8514 6.38658 11.387 6.38658C10.9225 6.38658 10.546 6.76309 10.546 7.22752C10.546 7.69196 10.9225 8.06846 11.387 8.06846Z",
    fill: "#58A493"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/addComment.e775372d72d82213d8ea4aabe4871f9a.svg";
export { ForwardRef as ReactComponent };